export const offerReports = {
  id: 'offers',
  name: 'Offers',
  description: '',
  visibility: 'private',
  subject_type: 'offers',
  layout: {
    data: [
      {
        h: 7,
        w: 4,
        x: 0,
        y: 0,
        key: '4812',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 4,
        x: 4,
        y: 0,
        key: '4813',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 4,
        x: 8,
        y: 0,
        key: '4814',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 9,
        y: 7,
        key: '4815',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 9,
        y: 14,
        key: '4816',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 8,
        w: 3,
        x: 9,
        y: 21,
        key: '4817',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 22,
        w: 9,
        x: 0,
        y: 7,
        key: '4818',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 6,
        x: 0,
        y: 29,
        key: '4819',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 6,
        x: 6,
        y: 29,
        key: '4820',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 18,
        w: 12,
        x: 0,
        y: 52,
        key: '4821',
        maxH: 100,
        maxW: 12,
        minH: 8,
        minW: 8,
      },
    ],
  },
  tiles: [
    {
      id: 4812,
      subject_type: 'offers',
      metadata: {
        id: 'offer_created',
        tileKey: 'offer_created',
        apiParam: 'card',
        headerKey: 'offers',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4813,
      subject_type: 'offers',
      metadata: {
        id: 'offer_time_to_offer',
        unit: 'time',
        tileKey: 'offer_time_to_offer',
        apiParam: 'card',
        // headerKey: 'time_to_offer',
        componentType: 'card',
        calculationType: 'avgChange',
        metricKeys: {
          numerator: 'time_to_offer',
          denominator: 'offers',
        },
      },
      query: null,
    },
    {
      id: 4814,
      subject_type: 'offers',
      metadata: {
        id: 'offer_revision_per_offer',
        tileKey: 'offer_revision_per_offer',
        apiParam: 'card',
        metricKeys: {
          numerator: 'revisions_on_offer',
          denominator: 'offers',
        },
        componentType: 'card',
        calculationType: 'avgChange',
      },
      query: null,
    },
    {
      id: 4815,
      subject_type: 'offers',
      metadata: {
        id: 'accepted_offers',
        tileKey: 'accepted_offers',
        apiParam: 'card',
        headerKey: 'accepted_offers',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4816,
      subject_type: 'offers',
      metadata: {
        id: 'offer_acceptance_rate',
        unit: 'percent',
        tileKey: 'offer_acceptance_rate',
        apiParam: 'card',
        metricKeys: {
          numerator: 'accepted_offers',
          denominator: 'offers',
        },
        componentType: 'card',
        calculationType: 'rateOfChange',
      },
      query: null,
    },
    {
      id: 4817,
      subject_type: 'offers',
      metadata: {
        id: 'rejected_offers',
        tileKey: 'rejected_offers',
        apiParam: 'card',
        headerKey: 'rejected_offers',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4818,
      subject_type: 'offers',
      metadata: {
        id: 'offers_trend_chart',
        tileKey: 'offers_trend_chart',
        apiParam: 'chart_table',
        headerKeys: [],
        componentType: 'chart',
      },
      query: null,
    },
    {
      id: 4819,
      subject_type: 'offers',
      metadata: {
        id: 'offers_department_chart',
        tileKey: 'offers_department_chart',
        apiParam: 'visual',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'department',
        },
      },
      query: null,
    },
    {
      id: 4820,
      subject_type: 'offers',
      metadata: {
        id: 'offers_location_chart',
        tileKey: 'offers_location_chart',
        apiParam: 'visual',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'appl_location',
        },
      },
      query: null,
    },
    {
      id: 4821,
      subject_type: 'offers',
      metadata: {
        id: 'offers_table',
        tileKey: 'offers_table',
        apiParam: 'chart_table',
        headerKeys: [
          'offers_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        componentType: 'table',
      },
      query: null,
    },
  ],
  user: {
    id: null,
  },
};
